import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import {updateSearchCondition} from '../../actions';

import {Time, Config} from '../../util';
import RadioButton from '../../components/radioButton';
import Select from '../../components/select';
import Input from '../../components/input';
import DatePicker from '../../components/datepicker';
import TimeList from '../../components/timelist';
import _ from 'lodash';
import Api from '../../util/api/Api';
import CheckBox from '../../components/checkbox';

class FilterContainer extends Component {
  constructor(props){
    super(props);

    this.state = {
      radioButtonValue: '1',
      chList: [],
    };
    this.handleCheckRadioButton = this.handleCheckRadioButton.bind(this);
  }

  componentDidMount() {
    this.getChList();
  }
  
  async getChList () {
    try{
      if(!sessionStorage.getItem('chList')){
        const result = await Api.GetChList({chNo: ''}); 
        const useChList = result.files.ch.filter(ch => ch.use === 'Y');
        const chList = _.keyBy(useChList, 'chName');
        sessionStorage.setItem('chList', JSON.stringify(chList));
      }
      const chListObj = JSON.parse(sessionStorage.getItem('chList'));
      this.setState({
        chList: chListObj
      });
    } catch(e) {
      console.log(e);
    }
  }


  handleCheckRadioButton = async (id, checkedValue) => {
    await this.setState({
      radioButtonValue: checkedValue
    });
    await this.props.updateSearchCondition(this.state.radioButtonValue)
    await this.props.handleOnSubmit();
  }

  render() {
    const {
      handleOnStartSelect,
      handleOnEndSelect,
      handleOnKeywordChange,
      handleOnStartSelectTime,
      handleOnStopSelectTime,
      handleOnStartCheck,
      handleOnTimeCheck,

      handleOnPrevPriceCheck,
      handleOnNextPriceCheck,
      handlePrevOnChange,
      handleNextOnChange,


      keyword,
      onStart,
      onStop,
      begDate,
      endDate,
      isStartDate,
      isCheckTime,

      prevPrice,
      nextPrice,
      prevPriceChk,
      nextPriceChk,
      isRerun,
      handleRerunYn

    } = this.props;
    const {
      chList,
      radioButtonValue
    } = this.state;

    const getChListDOM = () => {
      let list = [];
      for(let key in chList){
        if(chList[key].use === "Y"){
          const logoTitle = _.keyBy(Config.logoUrl, 'title')[key];
          list.push(
            <RadioButton id={key} name='chRadioNm' value={chList[key].chId}
            key={key}
            handleOnClick={this.handleCheckRadioButton} 
            checkedValue={radioButtonValue}>{logoTitle ? logoTitle.id : chList[key].chName}</RadioButton>
          );
        }
      }
      return list;
    }

    return (
      <div className='container filter search'>
      {Config.searchMode ? 
      <Fragment>
        <div className="select-container">
          {getChListDOM()}
        </div>
        <div className="datepicker-container">
          <DatePicker.ChkSingle 
                id='searchSDate'
                handleOnClick={handleOnStartCheck}
                checked={isStartDate}
                onSelect={handleOnStartSelect}
                defaultDate={begDate}
                dateFormat="YYYY-MM-DD"
                />
                ~
          <DatePicker.Single 
                  onSelect={handleOnEndSelect}
                  defaultDate={endDate}
                  dateFormat="YYYY-MM-DD"
                  />
        </div>
      </Fragment>
      :
        <Fragment>
          <Select onSelect={this.handleOnSelect} type="search"/>
          <div className="datepicker-container">
          <DatePicker.ChkSingle 
                id='searchSDate'
                handleOnClick={handleOnStartCheck}
                checked={isStartDate}
                onSelect={handleOnStartSelect}
                defaultDate={begDate}
                dateFormat="YYYY-MM-DD"
                />
                ~
          <DatePicker.Single 
                  onSelect={handleOnEndSelect}
                  defaultDate={endDate}
                  dateFormat="YYYY-MM-DD"
                  />
        </div>
          {/* <DatePicker.Range
            onStartSelect={handleOnStartSelect}
            onEndSelect={handleOnEndSelect}
            handleOnClick={this.handleOnChange}
            defaultStartDate={Time.getAddDate(Time.getToday(), -7)}
            defaultEndDate={Time.getAddDate(Time.getToday(), -1)}
          /> */}
        </Fragment>
      }
      
        <TimeList.RangeChk
          id='searchSTime'
          checked={isCheckTime}
          onStart={onStart}
          onStop={onStop}
          valueType="sec"
          onStartSelectTime={handleOnStartSelectTime}
          onStopSelectTime={handleOnStopSelectTime}
          onCheckTime={handleOnTimeCheck}
        />

        <Input.PriceFilter
            prevPrice={prevPrice}
            nextPrice={nextPrice}
            prevPriceChk={prevPriceChk}
            nextPriceChk={nextPriceChk}
            keyword={keyword}
            handlePrevOnChange={handlePrevOnChange}
            handleNextOnChange={handleNextOnChange}
            onPrevPriceCheck={handleOnPrevPriceCheck}
            onNextPriceCheck={handleOnNextPriceCheck}
            />
            <div className="input-container">
              <span className="subtitle">재방여부</span>
              <select value={isRerun} onChange={handleRerunYn}>
                <option value="">전체</option>
                <option value="0">본방</option>
                <option value="1">재방</option>
            </select>
            </div>
        <Input.Search keyword={keyword}
            onChange={handleOnKeywordChange}
            onSubmit={this.props.handleOnSubmit}/>
      </div>
    );
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    updateSearchCondition: (chs) => dispatch(updateSearchCondition({chs})),
  }
};


FilterContainer = connect(undefined, mapDispatcherToProps)(FilterContainer);

export default FilterContainer;


// WEBPACK FOOTER //
// ./src/containers/search/FilterContainer.js